module.exports = __webpack_public_path__ + "img/FSAB_StylizedFantasyAssassinBlade v2.e713652c.png";